import { useMemo } from 'react'
import { Navigate } from 'react-router-dom'

import { TContactStateRoutesMap, TGetItemFn, TSetItemFn } from '@/config/types'
import { CheckoutFlowVersion } from '@/enums/payments'
import { prepareContactStateRoutesMap } from '@/utils/paymentScreenUtils'

import { Spinner } from '@/components/spinner'

import useContactState from './useCheckContactState'

type TInProgressStateSettings =
  | {
      className: string
    }
  | {
      inProgressBlock: () => React.JSX.Element
    }

export type TProcessContactStateOptions = {
  stateRoutes?: TContactStateRoutesMap
} & TInProgressStateSettings

export function useProcessContactState(
  pageSetId: string,
  getItem: TGetItemFn,
  setItem: TSetItemFn,
  options: TProcessContactStateOptions,
  checkoutFlowVersion: CheckoutFlowVersion
): React.JSX.Element | undefined {
  const [stateCheckInProgress, contactState] = useContactState(
    pageSetId,
    getItem,
    setItem,
    checkoutFlowVersion
  )

  const stateRoutes = useMemo(
    () => prepareContactStateRoutesMap(options.stateRoutes || {}),
    [options.stateRoutes]
  )

  if (stateCheckInProgress) {
    if ('className' in options) {
      return (
        <div className={options.className}>
          <Spinner />
        </div>
      )
    } else {
      return options.inProgressBlock()
    }
  } else {
    if (contactState) {
      return <Navigate to={stateRoutes[contactState]} />
    }
  }
}
